











import Comment from "@/components/Comment.vue"
import tools from "@/tools.coffee"

export default {
    "name": "StateComments",
    "components": {Comment}
    "props":
        "comments": Array
        "active": true
    "data": ()->
        return {
            internal_comments: null
        }
    "watch":
        "comments": (new_value, old_value)->
            if new_value.length != old_value.length
                @internal_comments = tools.deep_copy(@comments)
    "methods":
        "scroll_down": ()->
            el = @$refs["comments"]
            el.scrollTop = el.scrollHeight
        "update_comment": (data)->
            # find the comment in data...
            # found = (i for i in @internal_comments when i.posted_on is
            # data.posted_on and i.who is data.who)[0]
            index = @internal_comments.findIndex((item) => item.posted_on is data.posted_on and item.who is data.who)
            # update data
            @internal_comments[index] = data
            @internal_comments[index].text = @internal_comments[index].text.replace(/(?:\r\n|\r|\n)/g, "<br>")
            @$emit("comments:updated", @internal_comments)
            return 

        "create_comment": (data)->
            @internal_comments.push(data)
            @$emit("comments:added", @internal_comments)
            @scroll_down
    "updated": ()->
        @scroll_down()
    "created": ()->
        @internal_comments = tools.deep_copy(@comments)
    "mounted": ()->
        @scroll_down()
        
}
